var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass:
        "bg-white shadow-sm border border-gray-200 overflow-hidden sm:rounded-sm",
      class: _vm.dark ? "md:rounded-xl" : "",
    },
    [
      _c(
        "div",
        {
          staticClass: "border-b border-gray-200 mb-4",
          class: _vm.dark ? "bg-gray-200" : "",
        },
        [
          _c(
            "div",
            { staticClass: "px-6 py-1.5" },
            [
              _vm._t("title", function () {
                return [
                  _c(
                    "p",
                    {
                      staticClass:
                        "xl:text-base font-semibold capitalize text-black",
                    },
                    [_vm._v(" " + _vm._s(_vm.title) + " ")]
                  ),
                ]
              }),
            ],
            2
          ),
        ]
      ),
      _c(
        "div",
        {
          staticClass: "flex text-gray-800",
          class: _vm.contentHorizontalPadding,
        },
        [
          _vm._t("prefix", function () {
            return [_c("p", [_vm._v(" " + _vm._s(_vm.prefix) + " ")])]
          }),
          _c(
            "div",
            { staticClass: "w-full text-gray-800 pt-1 pb-4" },
            [
              _vm._t("default", function () {
                return [
                  _vm.content
                    ? _c("p", { staticClass: "truncate" }, [
                        _vm._v(" " + _vm._s(_vm.content) + " "),
                      ])
                    : _c("p", { staticClass: "text-gray-400" }, [
                        _vm._v(" " + _vm._s(_vm.placeholder) + " "),
                      ]),
                ]
              }),
            ],
            2
          ),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }